import Mock from 'mockjs'
import data from './data.json'

Mock.mock('/invitePartner', {
  code: 200,
  message: 'success',
  result: 'success'
})

Mock.mock('/departmentList', {
  code: 200,
  message: 'success',
  result: data.departmentList
})

Mock.mock('/inviteTeamer', {
  code: 200,
  message: 'success',
  result: 'success'
})

Mock.mock('/clientList', {
  code: 200,
  message: 'success',
  result: data.clientList
})

Mock.mock('/tagList', {
  code: 200,
  message: 'success',
  result: data.tags
})

Mock.mock('/saveClientInfo', {
  code: 200,
  message: 'success',
  result: 'success'
})

Mock.mock('/teamerList', {
  code: 200,
  message: 'success',
  result: data.teamerList
})


Mock.mock('/updateDepartment', {
  code: 200,
  message: 'success',
  result: 'success'
})

Mock.mock('/createDepartment', {
  code: 200,
  message: 'success',
  result: 'success'
})

Mock.mock('/getRoleList', {
  code: 200,
  message: 'success',
  result: data.roleList
})

Mock.mock('/getPermissions', {
  code: 200,
  message: 'success',
  result: data.permissions
})

Mock.mock('/updateTeamer', {
  code: 200,
  message: 'success',
  result: 'success'
})

Mock.mock('/getUserInfo', {
  code: 200,
  message: 'success',
  result: {}
})

Mock.mock('/updatePwd', {
  code: 200,
  message: 'success',
  result: 'success'
})

Mock.mock('/getCompanyInfo', {
  code: 200,
  message: 'success',
  result: {}
})

Mock.mock('/getClientContract', {
  code: 200,
  message: 'success',
  result: data.clientContract
})

Mock.mock('/api/getCustomerLevels', {
  code: 200,
  message: 'success',
  result: data.customerLevels
})

Mock.mock('/chargeSituationList', {
  code:200,
  message:'success',
  result: data.chargeSituationList
})

Mock.mock('/contract',{
  code:200,
  message:'success',
  result:data.contract
})

Mock.mock('/workAssign',{
  code:200,
  message:'success',
  result:data.work
})


//////////////////
// WEBPACK FOOTER
// ./Mock/mock.js
// module id = null
// module chunks = 